import { useEffect, useState } from "react";
import { Box, Fade, Typography, useMediaQuery, useTheme } from "@mui/material";
import Lottie from "lottie-react";
import greenAnimation from "../assets/animation_arrow_green.json";
import purpleAnimation from "../assets/animation_arrow_purple.json";
import { useInView } from "react-intersection-observer";

export default function LoopyArrow({ color = "green", delay = 500 }) {
  const [show, setShow] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2, // adjust sensitivity
  });

  useEffect(() => {
    if (inView) {
      const timer = setTimeout(() => setShow(true), delay);
      return () => clearTimeout(timer);
    }
  }, [inView, delay]);

  return (
    <Box
      ref={ref}
      sx={{
        position: "relative",
        width: 150,
        height: 100,
        // border: "1px solid blue",
      }}
    >
      {show && (
        <Box
          sx={{
            width: 150,
            mx: "auto",
            transform: isMobile
              ? "rotate(30deg) scale(0.6)"
              : "rotate(-35deg) scaleX(1)",
            transformOrigin: "center",
          }}
        >
          <Lottie
            animationData={color === "green" ? greenAnimation : purpleAnimation}
            loop={false}
            speed={0.5}
            style={{
              width: 100,
              height: 100,
            }}
          />
        </Box>
      )}
      {!isMobile && (
        <Fade
          in={show}
          timeout={{ enter: 1000 }}
          style={{ transitionDelay: "500ms" }}
        >
          <Typography
            variant="body2"
            sx={{
              fontStyle: "italic",
              position: "absolute",
              lineHeight: 1.3,
              textAlign: "left",
              width: 150,
              bottom: isMobile ? 10 : 35,
              right: isMobile ? -90 : -115,
              // border: "1px solid red",
            }}
          >
            Try it now!
          </Typography>
        </Fade>
      )}
    </Box>
  );
}
